import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCargosVagosOcupadosMembrosInicio: [],
    buscaConsultaCargosVagosOcupadosMembrosErro: ['erro'],
    buscaConsultaCargosVagosOcupadosMembrosSucesso: ['consultaCargosVagosOcupadosMembros'],
    limpar: [],
    setConsultaCargosVagosOcupadosMembrosEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarQuadrosMembros = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCargosVagosOcupadosMembrosInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarCargosVagosOcupadosMembros(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaCargosVagosOcupadosMembrosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCargosVagosOcupadosMembrosErro(error)))
    }
}

const buscaConsultaCargosVagosOcupadosMembrosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCargosVagosOcupadosMembrosErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaCargosVagosOcupadosMembrosSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCargosVagosOcupadosMembros.resultado,
        dataSincronizacaoDados: action.consultaCargosVagosOcupadosMembros.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCargosVagosOcupadosMembrosEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CARGOS_VAGOS_OCUPADOS_MEMBROS_INICIO]: buscaConsultaCargosVagosOcupadosMembrosInicio,
    [Types.BUSCA_CONSULTA_CARGOS_VAGOS_OCUPADOS_MEMBROS_ERRO]: buscaConsultaCargosVagosOcupadosMembrosErro,
    [Types.BUSCA_CONSULTA_CARGOS_VAGOS_OCUPADOS_MEMBROS_SUCESSO]: buscaConsultaCargosVagosOcupadosMembrosSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CARGOS_VAGOS_OCUPADOS_MEMBROS_ESTADO_DT]: setConsultaCargosVagosOcupadosMembrosEstadoDT,
})
